import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { errorNotification, ERROR } from "../../utils/notifications";
import { readMessageBack } from "../../utils/readMessageBack";
import { MonitoringDTO } from "../../types/Monitoring";

interface State {
  issuedMonitoring: MonitoringDTO[];
  cancelledMonitoring: MonitoringDTO[];
  gettingIssuedMonitoring: boolean;
  gettingCancelledMonitoring: boolean;
}

const initialState: State = {
  issuedMonitoring: [],
  cancelledMonitoring: [],
  gettingIssuedMonitoring: false,
  gettingCancelledMonitoring: false
};

export default function monitoring(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case `${actionTypes.GET_ISSUED_INVOICES_MONITORING}_PENDING`: {
      return {
        ...state,
        issuedMonitoring: [],
        gettingIssuedMonitoring: true
      };
    }
    case `${actionTypes.GET_ISSUED_INVOICES_MONITORING}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        ...state,
        issuedMonitoring: [],
        gettingIssuedMonitoring: false
      };
    }
    case `${actionTypes.GET_ISSUED_INVOICES_MONITORING}_FULFILLED`: {
      return {
        ...state,
        issuedMonitoring: action.payload || [],
        gettingIssuedMonitoring: false
      };
    }

    case `${actionTypes.GET_CANCELLED_INVOICES_MONITORING}_PENDING`: {
      return {
        ...state,
        cancelledMonitoring: [],
        gettingCancelledMonitoring: true
      };
    }
    case `${actionTypes.GET_CANCELLED_INVOICES_MONITORING}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        ...state,
        cancelledMonitoring: [],
        gettingCancelledMonitoring: false
      };
    }
    case `${actionTypes.GET_CANCELLED_INVOICES_MONITORING}_FULFILLED`: {
      return {
        ...state,
        cancelledMonitoring: action.payload || [],
        gettingCancelledMonitoring: false
      };
    }

    default: {
      return state;
    }
  }
}

export { initialState };
